import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation, Optional } from '@angular/core';
import { MainService } from "../../Services/service.service";
import { ImageAttachComponent } from "../image-attach/image-attach.component";
import { DTOConversation, DTOImage } from "../../api/WickedApiClient";
import { removeEmojis } from '../../Helpers/EmojiHelper';
import { CompareVersionsComponent } from '../../Cms/compare-versions/compare-versions.component';
import { MatDialog } from '@angular/material';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'conv-send-message',
  templateUrl: './send-conversation-message.component.html',
  styleUrls: ['./send-conversation-message.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SendConversationMessageComponent implements OnInit {

  @Input() public captchaEnabled: boolean = false;
  @Input() public nickVisible: boolean = false;
  @Input() public acceptTermsEnable: boolean = false;
  @Input() public isNotFirstMessage: boolean = false;

  msg = new FormControl();
  nickname = new FormControl();

  constructor(public service: MainService, @Optional() public matDialog: MatDialog) {

  }

  advImagesCount: number = 0;

  ngOnInit() {
    if (this.currentConversation) {
      this.service.advService.getAdvertisementData(this.currentConversation.advertisementId).then(advGet => {
        let advertisement = advGet.adveristments[0];
        if (advertisement.userId == this.service.userService.getUserId() && advertisement.isPremium) {
          this._premiumAdvertisementMessages = true;
        }
        if(advertisement.userId == this.service.userService.getUserId() && advertisement.images.length > 0) this.advImagesCount = advertisement.images.length;
      });

      
    }

    this.msg.valueChanges.subscribe(val => {
      if (!this.isSpecialUser && !this.PremiumAdvertisementMessages) {
        this.msg.patchValue(removeEmojis(val), { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
      }
    });


    this.nickname.valueChanges.subscribe(val => {
      if (!this.isSpecialUser && !this.PremiumAdvertisementMessages) {
        this.nickname.patchValue(removeEmojis(val), { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
      }
    });
  }


  private _premiumAdvertisementMessages = false;
  get PremiumAdvertisementMessages(): boolean {

    return this._premiumAdvertisementMessages;
  }

  private _isSpecialUser: boolean = null;
  get isSpecialUser(): boolean {
    if (this._isSpecialUser == null) {
      this._isSpecialUser = this.service.userService.isDemo() || this.service.userService.isPremium() || this.service.userService.isAdmin();
    }
    return this._isSpecialUser;
  }

  private _currentContentCursorPosition: number = -1;


  get conversationMessageContent(): string {
    if (this.msg.value == null) {
      return "";
    }
    return this.msg.value;
  }

  set conversationMessageContent(value: string) {
    if (!this.isSpecialUser && !this.PremiumAdvertisementMessages) {
      value = removeEmojis(value);
    }
    this.msg.patchValue(value, { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
  }

  get nick(): string {
    if (this.nickname.value == null) {
      return "";
    }
    return this.nickname.value;
  }

  set nick(value: string) {
    if (!this.isSpecialUser && !this.PremiumAdvertisementMessages) {
      value = removeEmojis(value);
    }
    this.nickname.patchValue(value, { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
  }


 

  private _submitInProgress = false;

  get submitInProgress(): boolean {
    return this._submitInProgress;
  }

  set submitInProgress(value: boolean) {
    this._submitInProgress = value;
  }

  public get submitDisabled(): boolean {

    const content = this.conversationMessageContent;
    const contentValid = (content != null && true) && ("" != content.trim());
    const nickValid = !this.nickVisible || (this.nick != null && this.nick.trim() != "");
    return !(contentValid && nickValid);
  }

  @ViewChild("attachImage", { static: true }) imageAttachComponent: ImageAttachComponent;

  @Input() currentConversation?: DTOConversation;

  public hideRequirement: boolean = true;
  addContentEmoji(e: any) {
    let value = this.conversationMessageContent;
    if (!value) {
      value = "";
    }
    if (this._currentContentCursorPosition > -1 && value != "") {
      value = value.substring(0, this._currentContentCursorPosition) + " " + e.emoji.native + " " + value.substring(this._currentContentCursorPosition + 1, value.length)
    } else {
      value = e.emoji.native;
    }
    this.conversationMessageContent = value;
    console.log(e);
  }

  @Output() submitClick = new EventEmitter<SendConversationMessageComponent>();

  contentBlur(e: Event) {
    if (e.target['selectionStart'] != null) {
      this._currentContentCursorPosition = e.target['selectionStart'] as number;
    }
  }

  fireSubmitEvent($event: MouseEvent) {
    if(!this.acceptTermsEnable || this.termsaccept){
      const nickValid = !this.nickVisible || this.nick.trim() != '';
      const contentValid = (this.conversationMessageContent.trim() != '');
      if(this.conversationMessageContent.trim().length < 4000){
        if(( (this.isNotFirstMessage && this.imagesIsUploaded) || contentValid) && nickValid && this.isCaptchaOk()){
          this.submitClick.emit(this);
        }else{
          this.service.showError("Message form fields are invalid, fill them properly");
          this.hideRequirement = false;
        }
      }else{
        this.service.showError("The maximum length of the message is 4000 characters");
      }
    }else{
      this.service.showError("Please accept the terms and conditions before sending");
    }

  }

  prepareMessageContent(): string {
    return this.conversationMessageContent;
  }

  prepareMessageParams(): SendMessageParameters {
    return new SendMessageParameters(this.nick, this.prepareMessageContent(), this.imageAttachComponent.dtoImages())
  }

  updateMessage(text: string) {
    this.conversationMessageContent = text;
  }

  submitStart() {
    this.submitInProgress = true;
  }

  submitFinished() {
    this.imagesIsUploaded = false;
    this.submitInProgress = false;
  }

  clear() {
    this.conversationMessageContent = '';
    this.imageAttachComponent.clear();
  }

  public imagesIsUploaded:boolean = false;

  setImagesIsUploaded(status: boolean){
    this.imagesIsUploaded = status;
  }

  userImageConversationCount(userId: number): number {
    let count = 0;
    if (this.currentConversation != null && this.currentConversation.messages != null) {
      this.currentConversation.messages.filter(m => m.senderId == userId).forEach(message => {
        if (message.images != null) {
          count += message.images.length;
        }
      });
    }

    return count;
  }

  get userMaxImagesLength(): number {
    var maxImages = 1;
    maxImages -= this.userImageConversationCount(this.service.userService.getUserId());
    maxImages -= this.advImagesCount;
    return maxImages;
  }


  showMaxAttachmentsExceeded() {
    this.showCompareVersions();
  }


  showCompareVersions() {
    let item = this.matDialog.open(CompareVersionsComponent, {
      width: "80%",
      height: "810px",
      panelClass: "CompareVersionsComponent-panel",
      data: {
        isPopup: true,
        title: "Upgrade To Premium to send unlimited pictures"
      }
    })
    item.componentInstance.isPopup = true;
  }

  private termsaccept :boolean = false;
  private _captchaResolvedFlag = false;

  getCaptchaResolvedFlag(): boolean {
    return this._captchaResolvedFlag;
  }

  setCaptchaResolvedFlag(value) {
    this._captchaResolvedFlag = value;
  }

  captchaResolved(captchaResponse: string) {
    this.setCaptchaResolvedFlag(true)
  }

  captchaAvailable() {
    return this.service.captchaService.getCurrentCaptchaKey() != "";
  }

  onCheckChange(e){
     this.termsaccept = e.checked;
  }

  isCaptchaOk(): boolean {
    if (!this.captchaEnabled) {
      return true;
    }

    return this.captchaAvailable() && this._captchaResolvedFlag;
  }
}

export class SendMessageParameters {

  constructor(nick: string, content: string, images: DTOImage[] = []) {
    this.content = content;
    this.images = images;
    this.nick = nick;
  }

  public readonly content: string;
  public readonly nick: string;
  public readonly images: DTOImage[];
}

